<div class="progress-loader" [hidden]="!loading" role="alert" aria-busy="true">
  <div class="loading-spinner">
    <img
      src="/assets/Images/siteimages/falcon-loader.gif"
      class="img-loader"
      alt=""
    />
    <div class="counting_num">
      <span class="counting_per"></span><label for="">%</label>
    </div>
  </div>
</div>
